var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    typography = _ref.typography,
    borders = _ref.borders;
  return {
    feedbackSectionLeftMargin: spacing.xSmall,
    pointsInputFontSize: typography.fontSizeMedium
  };
};
export default generateComponentTheme;